export default __webpack_public_path__ + "static/media/checkMark.28bf8979.svg";